import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initHistoryConnectorsAnimation() {
  const section = document.querySelector('.history-storytelling');
  if (!section) return;

  const cards = document.querySelectorAll('.history-storytelling__card');
  const desktopConnectors = document.querySelectorAll('.history-storytelling__connector--desktop');
  const mobileConnectors = document.querySelectorAll('.history-storytelling__connector--mobile');
  
  if ((!desktopConnectors.length && !mobileConnectors.length) || !cards.length) return;

  // Animate card images rotation on scroll
  const images = section.querySelectorAll('.history-storytelling__image');
  const rotations = [-1.876, 4.35, -3.096, 3.776];
  
  images.forEach((image, index) => {
    const initialRotation = rotations[index % rotations.length];
    
    // Set initial rotation to the target rotation value
    gsap.set(image, { rotation: initialRotation });
    
    // Animate rotation to 0 on scroll
    gsap.to(image, {
      rotation: 0,
      scrollTrigger: {
        trigger: image,
        start: 'top 80%',
        end: 'center 60%',
        scrub: 1,
        markers: false
      }
    });
  });

  // Animate desktop connectors
  desktopConnectors.forEach((connector, index) => {
    animateConnector(connector, index, cards, false);
  });

  // Animate mobile connectors
  mobileConnectors.forEach((connector, index) => {
    animateConnector(connector, index, cards, true);
  });
}

function animateConnector(connector, index, cards, isMobile) {
    const svg = connector.querySelector('svg');
    const path = connector.querySelector('path');
    
    if (!path || !svg) return;

    // Position the connector between the corresponding cards
    const currentCard = cards[index];
    const nextCard = cards[index + 1];
    
    if (!currentCard || !nextCard) return;

    // Get connector type to determine animation direction
    const connectorType = connector.dataset.connectorType;
    const mobileConnector = connector.dataset.mobileConnector;
    const isRightToLeft = connectorType === 'right-left';

    // Get bounding box for clipPath BEFORE setting initial state
    const bbox = path.getBBox();
    
    // Create clipPath to animate the connector drawing
    const defs = svg.querySelector('defs') || svg.insertBefore(
      document.createElementNS('http://www.w3.org/2000/svg', 'defs'), 
      svg.firstChild
    );
    
    const clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
    const clipId = `connector-clip-${isMobile ? 'mobile' : 'desktop'}-${index}`;
    clipPath.setAttribute('id', clipId);
    
    const clipRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    
    // Set initial position based on mobile vs desktop
    if (isMobile) {
      // Mobile: draw from top to bottom
      clipRect.setAttribute('x', bbox.x);
      clipRect.setAttribute('width', bbox.width);
      clipRect.setAttribute('y', bbox.y);
      clipRect.setAttribute('height', '0');
    } else {
      // Desktop: draw left to right or right to left
      clipRect.setAttribute('y', bbox.y);
      clipRect.setAttribute('height', bbox.height);
      
      if (isRightToLeft) {
        // Start from the right edge, width 0
        clipRect.setAttribute('x', bbox.x + bbox.width);
        clipRect.setAttribute('width', '0');
      } else {
        // Start from the left edge, width 0
        clipRect.setAttribute('x', bbox.x);
        clipRect.setAttribute('width', '0');
      }
    }
    
    clipPath.appendChild(clipRect);
    defs.appendChild(clipPath);
    path.setAttribute('clip-path', `url(#${clipId})`);
    
    // Hide connector initially - AFTER setting up clipPath
    gsap.set(connector, { opacity: 0, visibility: 'hidden' });

    // Create animation timeline with scrub
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: connector,
        start: 'top 80%',
        end: 'bottom 60%',
        scrub: 1,
        markers: false // Set to true for debugging
      }
    });

    // Fade in and make visible, then draw it
    tl.set(connector, { visibility: 'visible' })
      .to(connector, { 
        opacity: 1, 
        duration: 0.2
      });
    
    // Animate based on mobile vs desktop
    if (isMobile) {
      // Mobile: animate from top to bottom by increasing height
      tl.to(clipRect, {
        attr: { height: bbox.height },
        duration: 1
      }, '-=0.05');
    } else {
      // Desktop: animate based on direction
      if (isRightToLeft) {
        // Animate from right to left: move x left while increasing width
        tl.to(clipRect, {
          attr: { 
            x: bbox.x,
            width: bbox.width 
          },
          duration: 1
        }, '-=0.05');
      } else {
        // Animate from left to right: just increase width
        tl.to(clipRect, {
          attr: { width: bbox.width },
          duration: 1
        }, '-=0.05');
      }
    }
}
